module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoAgMAAADxkFD+AAAADFBMVEVHcEz///////////8Gn9AKAAAAA3RSTlMA40mAJZ3FAAAANklEQVQY02NgAALOBAYYYL8AZ/J/oAETaBWQCbYQaBWQCbYQSEPQEGEiOR3JQ7QKM9RogVgFAIvGSz1HuAJMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu-icon/icon_slider@2x.png
// module id = r0xC
// module chunks = 13